import React from "react";

const FormCard = ({ icon, title, children, className = "" }) => {
  return (
    <section className={`bg-white p-8 rounded-xl border border-slate-200 shadow-sm ${className}`}>
      <div className="flex items-center gap-3 mb-8">
        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
          <span className="material-symbols-outlined text-lg">{icon}</span>
        </div>
        <h3 className="text-sm font-bold text-primary">{title}</h3>
      </div>
      {children}
    </section>
  );
};

export default React.memo(FormCard);